import type { PublicRuntimeConfig } from "nuxt/schema"

export function useRecaptcha() {
  const { recaptcha } = useRuntimeConfig().public as unknown as PublicRuntimeConfig

  if (!recaptcha.siteKey) {
    throw new Error('ReCaptcha error: No key provided')
  }

  const isReady = shallowRef<boolean>(false)
  const grecaptcha = ref<Window['grecaptcha']>()

  function awaitRecaptchaReady(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (isReady.value && grecaptcha.value) {
        return resolve()
      }

      const grecaptchaInstance = recaptcha.mode === 'enterprise' && window.grecaptcha?.enterprise ? window.grecaptcha.enterprise : window.grecaptcha

      const interval = setInterval(() => {
        if (grecaptchaInstance) {
          clearInterval(interval)
          grecaptchaInstance.ready(() => {
            grecaptcha.value = grecaptchaInstance
            isReady.value = true
            resolve()
          })
        }
      }, 100)

      setTimeout(() => {
        clearInterval(interval)
        reject(new Error('reCAPTCHA failed to load'))
      }, 10000)
    })
  }

  const execute = async (action: string) => {
    await awaitRecaptchaReady()

    if (!grecaptcha.value) {
      throw new Error('reCAPTCHA is not available')
    }
    return grecaptcha.value.execute(recaptcha.siteKey, { action })
  }

  return { execute }
}